import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	productComponents: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	productComponents: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.product-components',
		defaultMessage: '{product} components',
		description:
			'Button text showing whether Jira components or Compass components are enabled. Product will always be Jira or Compass.',
	},
});
export default messages;
